import { MatDateFormats } from '@angular/material/core';

export const MY_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'D',
  },
  display: {
    dateInput: 'd/M/yyyy',
    monthYearLabel: 'LLLL yyyy',
    dateA11yLabel: 'LLLL yyyy',
    monthYearA11yLabel: 'LLLL yyyy',
  }
};
